export const packageList = [
  {
    name: 'ec',
    activeRule: ['ec'],
  },
  {
    name: 'eam',
    activeRule: ['eam'],
  },
  {
    name: 'eam_marketing',
    activeRule: ['eam-marketing'],
  },
  {
    name: 'eam_user',
    activeRule: ['eam-user'],
  },
  {
    name: 'eam_tools',
    activeRule: ['eam-tools'],
  },
  {
    name: 'eam_order',
    activeRule: ['eam-order'],
  },
  {
    name: 'eam_report',
    activeRule: ['eam-report'],
  },
  {
    name: 'eam_common',
    activeRule: [],
  },
  {
    name: 'eam_monitor',
    activeRule: ['eam-monitor'],
  },
]

export const remoteModuleConfig = {
  dev: ['ec', 'eam', 'eam_common', 'eam_marketing', 'eam_user', 'eam_tools', 'eam_order', 'eam_report', 'eam_monitor'],
  stg: ['ec', 'eam', 'eam_common', 'eam_marketing', 'eam_user', 'eam_tools', 'eam_order', 'eam_report', 'eam_monitor'],
  uat: ['ec', 'eam', 'eam_common', 'eam_marketing', 'eam_user', 'eam_tools', 'eam_order', 'eam_report', 'eam_monitor'],
  prd: ['ec', 'eam', 'eam_common', 'eam_marketing', 'eam_user', 'eam_tools', 'eam_order', 'eam_report', 'eam_monitor'],
}



// WEBPACK FOOTER //
// ./src/layout/router/remote/package-list/eam/index.js